import { Routes } from '@angular/router';
import { LoginComponent } from './auth/login/login.component';
import { VerificationComponent } from './auth/verification/verification.component';
import { loginGuard } from './core/guards/login.guard';
import { authGuard } from './core/guards/auth.guard';
import { roleGuard } from './core/guards/role.guard';
import { maintenanceGuard } from './core/guards/maintenance.guard';
import { OnboardingComponent } from './auth/onboarding/onboarding.component';
import { ClearCachePageComponent } from './pages/clear-cache-page.component';
import { MaintenancePageComponent } from './pages/maintenance/maintenance-page.component';

export const routes: Routes = [
    {
        path: '',
        redirectTo: 'auth/login',
        pathMatch: 'full'
    },
    {
        path: 'maintenance',
        component: MaintenancePageComponent
    },
    {
        path: 'auth/login',
        component: LoginComponent,
        canActivate: [loginGuard]
    },
    {
        path: 'auth/verification',
        component: VerificationComponent
        // Pas de guard ici pour permettre la vérification OTP
    },
    {
        path: 'auth/onboarding',
        component: OnboardingComponent,
        canActivate: [authGuard, maintenanceGuard]
    },
    {
        path: 'dashboard',
        loadChildren: () => import('./features/dashboard/dashboard.routes').then(m => m.DASHBOARD_ROUTES),
        canActivate: [authGuard, maintenanceGuard]
    },
    {
        path: 'manager',
        loadChildren: () => import('./features/manager/manager.routes').then(m => m.MANAGER_ROUTES),
        canActivate: [authGuard, roleGuard, maintenanceGuard],
        data: { roles: ['manage'] }
    },
    {
        path: 'notifications',
        loadComponent: () => import('./features/notifications/pages/notification-page/notification-page.component').then(m => m.NotificationPageComponent),
        canActivate: [authGuard, maintenanceGuard]
    },
    {
        path: 'clear-cache',
        component: ClearCachePageComponent
    },
    {
        path: '**',
        redirectTo: 'auth/login'
    }
];
